import React, { useState, useContext } from 'react';
import { Button, Modal, Space, Tag } from 'antd';
import Axios from 'axios';
import * as AntdIcons from '@ant-design/icons';

import { DatasetGrid } from './DatasetGrid';
import { AuthContext } from '../../containers/App';
import * as COM from '.';

export const DatasetGridSelect = (props) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [datasetGridSelectedIds, setDatasetGridSelectedIds] = useState([]);
  const [datasetGridSelected, setDatasetGridSelected] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selected, setSelected] = useState([]);
  const [value, setValue] = useState(null);
  const auth = useContext(AuthContext);

  const setDefault = async () => {
    try {      
      let data = await COM.fetchData({
        connector: props.connector,
        dataset: props.dataset,
        filters: {
          "id": {
            "$in": props.value
          }
        }
      }, auth);
      let fetchedSelectedIds = [];
      let fetchedSelected = [];      
      for (let item of data) {
        fetchedSelectedIds.push(item.id);
        fetchedSelected.push(item);
      }      
      setDatasetGridSelectedIds(fetchedSelectedIds);
      setDatasetGridSelected(fetchedSelected);
      setSelectedIds(fetchedSelectedIds);
      setSelected(fetchedSelected);      
      return data;
    } catch (err) {
      console.log(err);
    }
  }

  if (props.value && !value) {
    setDefault();
    setValue(props.value);
  }

  const onOpenModal = async () => {
    setModalVisible(true);
  }

  const onModalOk = async () => {
    setSelectedIds(datasetGridSelectedIds);
    setSelected(datasetGridSelected);
    if (props.onChange) {
      props.onChange(props.multiple ? datasetGridSelectedIds : datasetGridSelectedIds[0]);
    }
    setModalVisible(false);
  }

  const onModalCancel = async () => {
    setDatasetGridSelectedIds(selectedIds);
    setDatasetGridSelected(selected);
    setModalVisible(false);
  }

  const rowSelection = {
    fixed: true,
    columnWidth: 40,
    // type: 'checkbox',
    type: props.multiple ? 'checkbox' : 'radio',
    selectedRowKeys: datasetGridSelectedIds,
    onSelect: (record, selected, selectedRows) => {
      setDatasetGridSelectedIds(selectedRows.map((child) => child.id));
      setDatasetGridSelected(selectedRows);
    },
  };

  return (
    <div>
      <Space>
        <Button
          size="small"
          onClick={onOpenModal}
        >
          <AntdIcons.DashOutlined />
        </Button>
        {selected.length < 1
          ? "Nothing selected"
          : selected.map((child, idx) =>
            <Tag
              key={idx}
            >
              {child.displayName}
            </Tag>
          )}
      </Space>
      <Modal
        title={"Filter by " + props.dataset}
        visible={modalVisible}
        onOk={onModalOk}
        onCancel={onModalCancel}
        closable={true}
        width={'90%'}
        style={{ top: 20 }}
      >
        <DatasetGrid
          allowSearch={true}
          allowSettings={true}
          connector={props.connector}
          dataset={props.dataset}
          filters={props.filters}
          rowSelection={rowSelection}
        />
      </Modal>
    </div>
  );
};